var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadAllIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 20849"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.1997 6.99966L17.1997 15.3997M17.1997 15.3997L14.1997 11.7997M17.1997 15.3997L20.1997 11.7997",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M8.80029 6.99966L8.80029 15.3997M8.80029 15.3997L5.80029 11.7997M8.80029 15.3997L11.8003 11.7997",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M5.79971 18.9998L12.9997 18.9998L20.1997 18.9998",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M25 12.9998C25 18.6566 25 21.485 23.2426 23.2424C21.4853 24.9998 18.6569 24.9998 13 24.9998C7.3432 24.9998 4.51468 24.9998 2.7574 23.2424C1 21.485 1 18.6566 1 12.9998C1 7.34295 1 4.51443 2.7574 2.75715C4.51468 0.999754 7.3432 0.999753 13 0.999754C18.6569 0.999754 21.4853 0.999755 23.2426 2.75716C25 4.51444 25 7.34295 25 12.9998Z",
    stroke: "white",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadAllIcon);
export default __webpack_public_path__ + "static/media/DownloadAllIcon.e5f6273d2260eb8e6541a3e6575a70d7.svg";
export { ForwardRef as ReactComponent };